import { List } from "devextreme-react"
import React, { FunctionComponent, useCallback, useEffect, useState } from "react"
import { categories } from "./data"
import { SelectionChangedEvent } from "devextreme/ui/list"

interface ProfileCategoriesProps {
    setSelectedKey: React.Dispatch<React.SetStateAction<number>>;
    selectedKey: number;    
}

const ProfileCategories: FunctionComponent<ProfileCategoriesProps> = (props) => {
    
    const {selectedKey, setSelectedKey} = props

    const onSelectedItemKeysChange = useCallback((e:SelectionChangedEvent) => {
        if (e?.addedItems.length>0) 
            setSelectedKey(e.addedItems[0].id)
    },[])

    return (
        <div>
            <List id="profileCategories"
                dataSource={categories}

                showSelectionControls={false}
                selectionMode={"single"}
                selectAllMode={"allPages"}
                selectByClick={true}
                onSelectionChanged={onSelectedItemKeysChange}
            >
            </List>
        </div>
    )
}

export default ProfileCategories